module.exports = __webpack_public_path__ + "img/icon_age.4311df7b.png";